import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=75d13024&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=ts&"
export * from "./TaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=75d13024&prod&scoped=true&lang=stylus&"
import style1 from "./TaskCard.vue?vue&type=style&index=1&id=75d13024&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d13024",
  null
  
)

export default component.exports